import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

import paket from '../assets/img/svg/shop.svg'
import cekici from '../assets/img/svg/car_ico.svg'
import tasima from '../assets/img/svg/ico_Dealer.svg'
import bayi from '../assets/img/svg/ico_Dealer.svg'

function Online() {
    const onlineCards = [
        {
            title: 'Yol yardım paketleri',
            description: 'Online paket satın alarak yıl boyunca yol yardım hizmetlerinden faydalanabilirsiniz. ',
            buttonText: 'YOL YARDIM PAKETLERİ',
            buttonHref: '/tr/paketler',
            color: 'linear-gradient(135deg,#066800 0%,#0bd200 100%)',
            iconBg: 'linear-gradient(135deg, #066800 0%, #0bd200 100%)',
            icon: paket,
            delay: 200
        },
        {
            title: 'Şehirler Arası Araç Taşıma',
            description: 'İller arası güvenli araç taşıma ve çekici hizmeti hakkında bilgi alın, cazip fiyatlarla hizmet alın.',
            buttonText: 'DETAYLI BİLGİ',
            buttonHref: '/tr/hizmetlerimiz/sehirler-arasi-arac-tasima',
            color: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            icon: tasima,
            delay: 200
        },
        {
            title: 'Anında Çekici Çağır',
            description: 'Konumunuzu paylaşın, araç bilgilerinizi girin ve birkaç adımda 7/24 çekici talebi oluşturun.',
            buttonText: 'ÇEKİCİ ÇAĞIR',
            buttonHref: '/tr/cekici-cagir',
            color: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            icon: cekici,
            delay: 300
        },
        {
            title: 'Bayilik Başvurusu',
            description: 'Sigorta Acentelerine sunulan ayrıcalıklı hizmetlerimizden faydalanmak için bayilik başvurusu yapabilirsiniz.',
            buttonText: 'BAYİ BAŞVURUSU',
            buttonHref: '/tr/online-islemler/bayilik-basvurusu',
            color: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            iconBg: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            icon: bayi,
            delay: 400
        }
    ];

    return (
        <>
        <section className="c-services u-relative">
                <div className="c-services__wrapper">
                    <div className="o-container">

            <section className="c-brands u-relative modern-online">
                <div className="c-brands__wrapper">
                    <div className="page-content">  
                        <div className="c-col__row elegant-online-row">
                            {onlineCards.map((card, index) => (
                                <div 
                                    key={index} 
                                    className="c-col c-col-3 elegant-online-item" 
                                    data-aos="fade-up" 
                                    data-aos-delay={card.delay}
                                >
                                    <div className="elegant-online-card">
                                        <div className="elegant-online-card__header">
                                            <div className="elegant-online-card__icon" style={{ background: card.iconBg }}>
                                                <img 
                                                    src={card.icon} 
                                                    alt={card.title} 
                                                    className="elegant-icon-image"
                                                />
                                            </div>
                                            <div className="elegant-online-card__decoration-line"></div>
                                        </div>
                                        <div className="elegant-online-card__body">
                                            <div className="elegant-online-card__title">{card.title}</div>
                                            <div className="elegant-online-card__description">
                                                {card.description}
                                            </div>
                                        </div>
                                        <div className="elegant-online-card__footer">
                                            <a 
                                                href={card.buttonHref} 
                                                className="elegant-online-card__button"
                                                style={{ background: card.color }}
                                            >
                                                <span className="button-text">{card.buttonText}</span>
                                                <span className="button-arrow">→</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            </div>
            </div>
        </section>
        </>
    );
};

export default Online;
